import React, { useState } from 'react';

import { SearchContext } from './search-context';
import SearchClearFilter from './search-clear-filter'
import Button from '../../ui/components/button'
import Drawer from '../../page/components/drawer';

import '../css/search-drawer.less'

function SearchDrawer({ children, label, className, watchFields, position, resultCount, buttonProps, onClearFilter }) {
    const [isOpen, closeDrawer] = useState(false);

    let clearFunction = typeof onClearFilter === 'function' ? onClearFilter : () => closeDrawer(!isOpen);
    return (
        <>
            <SearchContext.Consumer>
                {({ filterCount }) => {
                    return (
                    <div className={'search-drawer-button-container'}>
                    <Button className={'search-drawer-button'} action='none' color={'white'} onClick={() => closeDrawer(!isOpen)} {...buttonProps || {}}>
                        {label}{filterCount > 0 && <span className={'count'}>({filterCount})</span>}
                    </Button></div>);
                }}
            </SearchContext.Consumer>
            <Drawer open={isOpen} position={position} className={`search-drawer${className ? ' ' + className : ''}`}>
                {/* TODO: could put default filter menu here if none provided*/}
                {children({ closeDrawer: () => closeDrawer(!isOpen) })}
                <SearchContext.Consumer>
                    {({  hits }) => {
                        const displayCount = typeof resultCount !== 'undefined' ? resultCount : hits;
                        return (<div className={'footer'}>
                                    {/*TODO: taking a short cut here with the buton classNames. We can update with proper Button component after the test*/}
                                    <SearchClearFilter 
                                        onClick={clearFunction}
                                        watchFields={watchFields} 
                                        className={'button-animated secondary primary large'} />
                                    <Button 
                                        className={'see-results'} text={`SHOW ${displayCount} RESULTS`} 
                                        action='none' color={'primary'} onClick={() => closeDrawer(!isOpen)}/>
                                </div>);
                    }}
                </SearchContext.Consumer>
            </Drawer>
        </>
    );
}

SearchDrawer.defaultProps = {
    label: "Filter",
    position: 'left'
}

export default SearchDrawer;